// "Goes with what's in your cart" (P2-38; P2-05 for the first version).
// <m-cart-recommendations> sits under the cart lines (snippets/cart-drawer.liquid, sections/cart-template.liquid), so the
// cart re-creates it after every change. It loads sections/cart-recommendations.liquid through the Section Rendering
// API on the cart route, which reads the whole cart: once the drawer is open, or at once on the cart page. Add puts the
// product in the cart in place, re-rendering the drawer like the product form does; the cart page reloads.
if (!customElements.get("m-cart-recommendations")) {
  class MCartRecommendations extends HTMLElement {
    connectedCallback() {
      this.drawer = this.closest("m-cart-drawer");
      // The cart page renders the block with the page (data-rendered): only the Add buttons need wiring.
      if (this.hasAttribute("data-rendered")) {
        this.bind();
        this.loaded = true;
        return;
      }
      if (!this.dataset.url) return;
      if (!this.drawer || this.drawer.classList.contains("m-cart-drawer--active")) {
        this.load();
      } else {
        this.unsubscribe = window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, () => this.load());
      }
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    load() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      if (this.unsubscribe) {
        this.unsubscribe();
        this.unsubscribe = null;
      }
      const url = `${this.dataset.url}?section_id=cart-recommendations`;
      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const block = new DOMParser().parseFromString(html, "text/html").querySelector(".m-cart-recs");
          if (block) {
            this.innerHTML = block.outerHTML;
            this.bind();
          }
          this.loaded = true;
        })
        .catch((error) => console.error(error))
        .finally(() => {
          this.loading = false;
        });
    }

    bind() {
      this.querySelectorAll("button[data-variant-id]").forEach((button) => {
        button.addEventListener("click", () => this.add(button));
      });
    }

    add(button) {
      const drawer = this.drawer || document.querySelector("m-cart-drawer");
      button.disabled = true;
      button.classList.add("is-loading");
      const body = { items: [{ id: Number(button.dataset.variantId), quantity: 1 }] };
      if (drawer) {
        body.sections = [...new Set(drawer.getSectionsToRender().map((section) => section.id))];
        body.sections_url = window.location.pathname;
      }
      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((state) => {
          if (state.status) {
            button.disabled = false;
            button.classList.remove("is-loading");
            window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartError, { source: "cart-recommendations", message: state.message });
            return;
          }
          if (drawer && state.sections) {
            drawer.renderContents(state);
            drawer.getCart().then((cart) => drawer.updateCartCount(cart.item_count));
          } else if (!drawer) {
            window.location.reload();
            return;
          }
          window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { ...state, source: "cart-recommendations" });
        })
        .catch((error) => {
          console.error(error);
          button.disabled = false;
          button.classList.remove("is-loading");
        });
    }
  }

  customElements.define("m-cart-recommendations", MCartRecommendations);
}
